interface LogoMarkProps {
  size?: number
}

export function LogoMark({ size = 24 }: LogoMarkProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden>
      {/* Speech bubble — rounded corners, tail at bottom-left */}
      <path
        d="M8 4H24Q28 4 28 8V20Q28 24 24 24H11L5 29V8Q5 4 8 4Z"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Checkmark */}
      <path
        d="M10 14l4 4 8-8"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
